/**
 * Agent portal sort whitelists — must match backend agent endpoints (FR-006).
 * Reference: specs/009-agent-portal-column-sort/contracts/agent-portal-sort-api.md
 */
import type { ColumnSortSpec } from '../hooks/useTableSort';

export type TableSortKey =
  | 'agentCreditTransactions'
  | 'agentUsdLedger'
  | 'agentCashTransactions';

export const TABLE_SORT_CONFIG: Record<TableSortKey, ColumnSortSpec[]> = {
  // GET /api/agent/transactions
  agentCreditTransactions: [
    { key: 'created', label: 'Created', valueKind: 'datetime', defaultDirection: 'DESC' },
    { key: 'amount', label: 'Amount', valueKind: 'money', magnitude: true, defaultDirection: 'DESC' },
    { key: 'from', label: 'From', valueKind: 'text', defaultDirection: 'ASC' },
    { key: 'to', label: 'To', valueKind: 'text', defaultDirection: 'ASC' },
  ],

  // GET /api/agent/online-balance/ledger
  agentUsdLedger: [
    { key: 'amount', label: 'Amount', valueKind: 'money', magnitude: true, defaultDirection: 'DESC' },
    { key: 'createdAt', label: 'Created', valueKind: 'datetime', defaultDirection: 'DESC' },
    { key: 'balanceAfter', label: 'Balance after', valueKind: 'money', defaultDirection: 'DESC' },
  ],

  // GET /api/agent/cash-transactions — no Created column on agent portal (FR-005)
  agentCashTransactions: [
    { key: 'creditAmount', label: 'Credits', valueKind: 'money', defaultDirection: 'DESC' },
    { key: 'cashReceived', label: 'Cash', valueKind: 'money', defaultDirection: 'DESC' },
    { key: 'buyerCostRate', label: 'Cost', valueKind: 'money', defaultDirection: 'DESC' },
  ],
};

export function getTableSortColumns(table: TableSortKey): ColumnSortSpec[] {
  return TABLE_SORT_CONFIG[table];
}
